import React from 'react';
import { Route, Redirect, Link } from 'react-router-dom';
import { Container, NavDropdown } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import qs from 'qs';
import jwtDecode from 'jwt-decode';
import { NavbarTop, NavbarLogged, Footer } from '../components';
import HubSpotChat from '../components/HubSpotChat';
import IntercomChat from '../components/IntercomChat';
import { requestSignOut } from '../actions/auth';

export const LoggedLayout = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  return (
    <Route
      {...rest}
      render={props =>
        localStorage.getItem('jwt') ? (
          <>
            <NavbarLogged>
              <NavDropdown.Item as={Link} to="/slides">
                Slides
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => dispatch(requestSignOut())}>Cerrar Sesión</NavDropdown.Item>
            </NavbarLogged>
            <Container fluid>
              <Component {...props} />
            </Container>
            <Footer />
          </>
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        )
      }
    />
  );
};

export const NonLoggedLayout = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      localStorage.getItem('jwt') ? (
        <Redirect to={{ pathname: '/home', state: { from: props.location } }} />
      ) : (
        <>
          <NavbarTop />
          <Container fluid>
            <Component {...props} />
          </Container>
          <Footer />
        </>
      )
    }
  />
);

export const PublicLayout = ({ component: Component, containerClassName = '', ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => (
        <Container fluid className={containerClassName}>
          <Component {...props} />
        </Container>
      )}
    />
  );
};

export const TwistLayout = ({ component: Component, ...rest }) => {
  // const { fjwt } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
  return (
    <Route
      {...rest}
      render={props => {
        const { fjwt, jwt } = qs.parse(props.location.search, {
          ignoreQueryPrefix: true
        });
        localStorage.setItem('fjwt', fjwt);
        const { language } = jwtDecode(jwt);
        localStorage.setItem('language', language);

        return fjwt ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/home', state: { from: props.location } }} />
        );
      }}
    />
  );
};

// Unified OTP login + tenant picker (root path). Distinct from
// NonLoggedLayout/LoggedLayout on purpose: those gate on localStorage.jwt
// (micro-back's own session concept), unrelated to the AppUser identity
// flow, which uses its own localStorage.appUserJwt key.
export const UnifiedLoginLayout = ({ component: Component, ...rest }) => (
  // Rendered bare (no Bootstrap Container): the unified login manages its own
  // full-viewport gradient layout - a padded container would offset it and
  // introduce horizontal scroll.
  // Intercom lives only here: it is the entry point where a user who cannot log
  // in needs support, and there is no tenant/user identity to send yet.
  <Route
    {...rest}
    render={props => (
      <>
        <IntercomChat />
        <Component {...props} />
      </>
    )}
  />
);

export const OnboardingLayout = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => (
        <div style={{ width: '100%', overflowX: 'hidden' }}>
          <HubSpotChat />
          <Component {...props} />
        </div>
      )}
    />
  );
};

export const TwistLayoutContainer = ({ component: Component, ...rest }) => {
  // const { fjwt } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
  return (
    <Route
      {...rest}
      render={props => {
        const { fjwt, jwt } = qs.parse(props.location.search, {
          ignoreQueryPrefix: true
        });
        localStorage.setItem('fjwt', fjwt);
        const { language } = jwtDecode(jwt);
        localStorage.setItem('language', language);

        return fjwt ? (
          <Container fluid>
            <Component {...props} />
          </Container>
        ) : (
          <Redirect to={{ pathname: '/home', state: { from: props.location } }} />
        );
      }}
    />
  );
};
